import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RevisionViewComponent } from './revision-view/revision-view.component';
import { RevisionCreateComponent } from './revision-create/revision-create.component';
import { RevisionUpdateComponent } from './revision-update/revision-update.component';
import { RevisionIndexComponent } from './revision-index/revision-index.component';
import { RouterModule, Routes } from '@angular/router';
import { NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TipoAceiteCreateComponent } from './tipo-aceite-create/tipo-aceite-create.component';
import { NgxMaskModule } from 'ngx-mask';

const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  { path: 'create', component: RevisionCreateComponent },
  { path: 'index', component: RevisionIndexComponent },
];

@NgModule({
  declarations: [
    RevisionViewComponent,
    RevisionCreateComponent,
    RevisionUpdateComponent,
    RevisionIndexComponent,
    TipoAceiteCreateComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    NgbModalModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgxMaskModule, 
    NgSelectModule,
    NgbNavModule
  ]
})
export class RevisionModule { }
